<div class="item-list">
  @for (item of bundleItems(); track item.id + item.quantity) {
    @let slotState = bundleState().slotMap.get(item.slotId ?? '');

    <div class="item">
      <img [src]="item.images[0].small" alt="" />
      <div class="container-bundle-item-data">
        <span class="title">{{ item.details.name }}</span>
        <span class="subtitle">{{ item.quantity }}x
          @if (canSeePrices() && item.prices; as prices) {
            <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="prices.salesUnit"></ui-product-prices-formatter>
          }</span>
      </div>

      <div class="container-price-and-controls">
        @if (canSeePrices() && item.prices; as prices) {
          @let fullPrice = prices.salesUnit * item.quantity;
          <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="fullPrice"></ui-product-prices-formatter>
        }

        <button
          [class.invisible-button]="slotState?.slotType !== 'choice'"
          (click)="removeItem(item)"
          [disabled]="slotState?.slotType !== 'choice'">
          <ui-icon faName="trash" faStyle="light"></ui-icon>
        </button>
      </div>

    </div>
  }
</div>
